import {CartAuthNotificationBanner} from 'modules/Cart/components/CartAuthNotificationBanner/CartAuthNotificationBanner';
import {CartAuthPanel} from 'modules/Cart/containers/CartAuthPanel/CartAuthPanel';
import {CartForm} from 'modules/Cart/containers/CartForm/CartForm';
import {CartHeader} from 'modules/Cart/containers/CartHeader/CartHeader';
import {CART_LAYOUT_ELEMENT_ID} from 'modules/Cart/containers/CartLayout/CartLayout';
import {useCartOrderLayout} from 'modules/Cart/containers/CartOrderLayout/useCartOrderLayout';
import {CartProducts} from 'modules/Cart/containers/CartProducts/CartProducts';
import {OrderCartSidebar} from 'modules/Cart/containers/OrderCartSidebar/OrderCartSidebar';
import {useCartAuthContext} from 'modules/Cart/contexts/cartAuthContext';
import {CartStep, useCartContext} from 'modules/Cart/contexts/cartContext';
import {useEffect} from 'react';
import {FCC} from 'types/react';

import styles from './CartOrderLayout.module.css';

type Props = {};
export const CartOrderLayout: FCC<Props> = () => {
    const {step} = useCartContext();
    const {shouldShowAuthNotification} = useCartOrderLayout();

    const {withAuth} = useCartAuthContext();

    useEffect(() => {
        if (step === CartStep.Order) {
            const cartLayout = document.getElementById(CART_LAYOUT_ELEMENT_ID);
            cartLayout?.scrollIntoView({behavior: 'smooth'});
        }
    }, [step]);

    return (
        <div>
            <CartHeader className={styles.header} />
            <div className={styles.main}>
                <div className={styles.content}>
                    {withAuth && (
                        <>
                            <CartAuthPanel className={styles.authBanner} />
                            {shouldShowAuthNotification && (
                                <CartAuthNotificationBanner
                                    className={styles.authNotification}
                                />
                            )}
                        </>
                    )}

                    {step === CartStep.Products && <CartProducts />}
                    {step === CartStep.Order && <CartForm />}
                </div>
                <div className={styles.sidebar}>
                    <OrderCartSidebar />
                </div>
            </div>
        </div>
    );
};
